<h2 class="subtitle" grtSubtitle>
    Example Sentence
</h2>
<form (submit)="next.emit()">
    <div class="columns">
        <div class="column is-half">
            <div class="field has-addons">
                <div class="control is-expanded">
                    <input type="text" class="input" placeholder="Please give a sentence" [value]="inputSentence"
                        (keyup)="inputChanges($event)" (change)="inputChanges($event)" spellcheck="true" lang="nl"
                        [ngClass]="{'is-danger':warning}">
                </div>
                <div class="control">
                    <button type="submit" class="button" [disabled]="inputSentence.length === 0"
                        [ngClass]="{'is-danger':warning, 'is-primary': !warning}">Parse</button>
                </div>
            </div>
        </div>
    </div>
</form>
